import { useMutation } from "@tanstack/react-query";
export const createApiKeysQueries = (requests) => ({
    useGenerateExternalApiKey: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.generateExternalApiKey,
    }),
});
//# sourceMappingURL=index.js.map